import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useCallback } from 'react';
import strings from '../Globalization'

const ConfirmDialog = ({ title, body, open, cancelButtonText = 'Cancel', okButtonText = 'Ok', onCancel, onConfirm }) => {
	const handleClose = useCallback(
		(event) => {
			const { id } = event.currentTarget.dataset;
			if (id === 'ok') {
				onConfirm();
			} else if (onCancel) {
				onCancel();
			}
		},
		[onConfirm, onCancel]
	);

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{title || 'Alert'}</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">{body}</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ justifyContent: 'center' }}>
				<Button color="error" variant="contained" data-id="cancel" onClick={handleClose}>
					{strings[cancelButtonText] || cancelButtonText}
				</Button>
				<Button data-id="ok" variant="contained" color="success" onClick={handleClose} autoFocus>
					{okButtonText}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ConfirmDialog